// extracted by mini-css-extract-plugin
export default {"topBar":"style_topBar__2tFxA","title":"style_title__rKbVh","subtitle":"style_subtitle__GnqSt"};